'use client';

import Image from 'next/image';
import { useTranslations } from 'next-intl';
import { Switch } from '@/components/ui/switch';

type Props = {
  checked: boolean;
  onChange: (checked: boolean) => void;
  label?: string;
};

export const FreePriceToggle: React.FC<Props> = ({ checked, onChange, label }) => {
  const t = useTranslations('manageProduct');

  return (
    <div className='flex justify-between items-center'>
      <div className='flex items-center gap-[8px]'>
        <div className='flex items-center justify-center w-[44px] h-[44px] rounded-[50%] bg-bg2-day'>
          <Image src='/assets/icons/free-item.svg' width={22} height={22} alt='' />
        </div>

        <span className='text-primary text-[16px] font-normal'>{label || t('free_product')}</span>
      </div>

      <Switch onCheckedChange={onChange} checked={checked} />
    </div>
  );
};
